import React, { Component } from "react";
import { compose } from 'redux'
import { connect } from 'react-redux'
import { firebaseConnect } from 'react-redux-firebase'
import Dropzone from 'react-dropzone'
import { Button, FormGroup, FormControl, Form, ControlLabel, Radio, Col, Row, Image } from 'react-bootstrap';
import { map } from 'lodash'
import {SortableContainer, SortableElement} from 'react-sortable-hoc';

import spinner from './images/spinner.gif'
import './AdminEditor.css';

const RedAsterisk = () => {
  return (
    <span style={{color: "red"}}>&nbsp;&#42;</span>
  );
}

const RadioGroup = ({label, name, checkedValue, values, onChange}) => {
  let radioButtons = 
    values.map(value => (
      <Radio key={value} name={name} onChange={onChange} value={value} checked={checkedValue===value} required>
        {value}
      </Radio>
    ));
  return (
    <FormGroup>
      <ControlLabel>{label}</ControlLabel>
      <RedAsterisk/>
      {radioButtons}
    </FormGroup>
  );
}

const SortableItem = SortableElement(({imageKey, value, onFileDelete}) => {
  let url = value.url || value.downloadURL;
  return (
    <div key={imageKey} className={"child-box dropzone-image-container " + (value.processed ? "image-processed" : "image-processing")}>
      <i className="material-icons delete-image" onClick={() => onFileDelete(value, imageKey)}>delete</i>
      <Image src={url} responsive className="dropzone-image" onContextMenu={() => {return false}} />
      <div className="processing-text">
        Processing
      </div>
    </div>
  )
});

const SortableList = SortableContainer(({images, onFileDelete}) => {
  if (!images) {
    return <div />;
  }
  return (
    <div className="parent-box">
      {
         Object.keys(images)
         .sort((a, b) => images[a].index - images[b].index)
         .map(key => <SortableItem key={key} index={images[key].index} imageKey={key} value={images[key]} onFileDelete={onFileDelete} />)
      }
    </div>
  )
});

class AdminEditor extends Component {
  constructor(props) {
    super(props)
    this.state = {uploading: false}
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.images && Object.values(nextProps.images).map(image => image.index).includes(undefined)) {
      return false
    }
    return true
  }

  onFilesDrop = (files) => {
    var numImages = this.props.images ? Object.values(this.props.images).length: 0
    this.props.firebase
      .uploadFiles(this.props.imagesPath, files, this.props.imagesPath)
      .then(files => {
        this.setState({uploading: false})
        files.map(file => 
          this.props.firebase.update(`images/${this.props.projectKey}/${file.key}`, {index: numImages++})
        )
      })
      .catch(err => {
        console.log(err)
      })
      this.setState({uploading: true})
  }

  onFileDelete = (file, key) => {
    let index = file.index
    this.props.firebase
      .deleteFile(file.fullPath, `${this.props.imagesPath}/${key}`)
      .then(file => {
        map(this.props.images, (image, key)=> {
          if (image.index > index) {
            this.props.firebase.update(`images/${this.props.projectKey}/${key}`, {index: image.index-1})
          }
        })
      })
      .catch(err => {
        console.log(err)
      })
  }

  onFileDeleteAll = () => {
    if (this.props.images) {
      map(this.props.images, (image, key) => this.props.firebase.deleteFile(image.fullPath, `${this.props.imagesPath}/${key}`))
    }
  }

  onDeleteProject = () => {
    this.onFileDeleteAll()
    let currIndex = this.props.projects[this.props.projectKey].index
    this.props.firebase
      .remove(`projects/${this.props.projectKey}`)
      .then(() => {
        map(this.props.projects, (project, key) => {
          if (project.index > currIndex) {
            this.props.firebase.update(`projects/${key}`, {index: project.index-1})
          }
        })
      })
  };

  onSortEnd = ({oldIndex, newIndex}) => {
    let updates = {};
    map(this.props.images, (image, key) => {
      if (image.index === oldIndex) {
        updates[`/images/${this.props.projectKey}/${key}`] = Object.assign({}, image, {index: newIndex})
      }
      if (image.index === newIndex) {
        updates[`/images/${this.props.projectKey}/${key}`] = Object.assign({}, image, {index: oldIndex})
      }
    })
    this.props.firebase.ref().update(updates)
  };

  render() {
    let projectPath = `projects/${this.props.projectKey}`
    let projectTypeValues = [];
    if (this.props.project) {
      switch (this.props.project.serviceType) {
        case "commercial":
          projectTypeValues = ["Office Building", "Restaurant"]
          break;
        case "staging":
        case "residential":
        default:
          projectTypeValues = ["Single Family", "Town House", "Condo"]
      }
    }
    return (
      this.props.project ?
        <Form className="project-form">
          <Row>
            <Button bsStyle="danger" className="delete-project" onClick={this.onDeleteProject}>Delete Project</Button>
            <h4>Fill project details</h4>
            <Col xs={12} md={4}>
              <FormGroup>
                <ControlLabel>Project Display Name</ControlLabel>
                <RedAsterisk/>
                <FormControl type="name"
                             value={this.props.project.name}
                             placeholder="Enter Project Name"
                             onChange={(e) => this.props.firebase.update(projectPath, {name: e.target.value})}
                             required />
              </FormGroup>

              <FormGroup>
                <ControlLabel>City</ControlLabel>
                <RedAsterisk/>
                <FormControl type="city"
                             value={this.props.project.city}
                             placeholder="City"
                             onChange={(e) => this.props.firebase.update(projectPath, {city: e.target.value})}
                             required />
              </FormGroup>

              <RadioGroup label="Project Type"
                          name="projectType"
                          checkedValue={this.props.project.houseType}
                          values={projectTypeValues}
                          onChange={(e) => this.props.firebase.update(projectPath, {houseType: e.target.value})} />

              <FormGroup controlId="formDescription">
                <ControlLabel>Description</ControlLabel>
                <FormControl componentClass="textarea" rows="5"
                             value={this.props.project.description || ""}
                             onChange={(e) => this.props.firebase.update(projectPath, {description: e.target.value})} />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <h4 key="project-editor-title">Drag or upload images</h4>
            <ul>
              <li>First picture is the gallery cover, should be landscape orientation.</li>
              <li>You can drag or delete a picture.</li>
              <li>After uploading, make sure to refresh page and check every picture has the watermark.</li>
            </ul>
            <SortableList axis="xy" distance={5} images={this.props.images} onSortEnd={this.onSortEnd} onFileDelete={this.onFileDelete}/>
            <Col xs={12} className="dropzone-container">
              <Col xs={4} md={2}>
                <Dropzone onDrop={this.onFilesDrop} className="dropzone">
                  +
                </Dropzone>
              </Col>
              <Col xs={4} md={2}>
                <Image src={spinner} style={{display: this.state.uploading ? "block" : "none"}} />
              </Col>
            </Col>
          </Row>
        </Form>
        : <div />
    )
  }
}

export default compose(
  firebaseConnect((props) => ([
    `images/${props.projectKey}`
  ])),
  connect(
    ({ firebase: { data } }, props) => ({
      imagesPath: `images/${props.projectKey}`,
      images: data.images && data.images[props.projectKey],
      projects: data.projects,
    })
  )
)(AdminEditor)



// WEBPACK FOOTER //
// ./src/AdminEditor.js